import { User, Cache } from '@skinsoft/types'
import { Proxy } from '@skinsoft/network'
import { DataStore } from '@skinsoft/data-store/src/data-store'

export class UserDataStore extends DataStore<User> {
    public static getInstance() {
        if (!UserDataStore.instance) {
            UserDataStore.instance = new UserDataStore();
        }

        return UserDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$userDataStore = UserDataStore.getInstance();
    }

    private static instance: UserDataStore = null as any;

    constructor(proxy?: Proxy, cache?: Cache<User>) {
        super('/users', undefined, undefined, undefined, proxy, cache);
    }

}
